import fs from 'fs';
export async function* generateJsonLines(filePath) {
  const fileStream = fs.createReadStream(filePath, { encoding: 'utf8' });
  let remainder = '';

  for await (const chunk of fileStream) {
    const lines = (remainder + chunk).split('\n');
    remainder = lines.pop(); // Keep the last partial line

    for (const line of lines) {
      if (line.trim()) {
        yield JSON.parse(line);
      }
    }
  }

  if (remainder.trim()) {
    yield JSON.parse(remainder);
  }
}
